<div class="input-group typeahead mercado-typeahead">
        <ng-template #typeaheadTemplate let-mercado="item">
            <span>{{mercado.codigoIntegracaoErp}} - {{mercado.nome}}</span>
            <span class="badge badge-danger" *ngIf="isSituacaoInativo(mercado.situacao)">{{mercado.situacao | mercadoSituacao}}</span>
        </ng-template>

        <div class="input-group-prepend">
            <span class="input-group-text">{{entity?.codigoIntegracaoErp}}</span>
        </div>        
        <input
            type="text"
            class="form-control"
            #inputTypeahead

            [typeahead]="typeaheadDataSource"
            [typeaheadWaitMs]="300"
            [typeaheadItemTemplate]="typeaheadTemplate"
            typeaheadOptionField="nome"
            [typeaheadMinLength]="2"
            [typeaheadOptionsLimit]="typeaheadOptionsLimit"
            [typeaheadScrollable]="true"
            [typeaheadOptionsInScrollableView]="typeaheadOptionsInScrollableView"
            [ngModel]="typeaheadSelected"
            (ngModelChange)="typeaheadToken = $event"
            (typeaheadOnSelect)="onSelectEntity($event)"
            (typeaheadNoResults)="onChangeTypeaheadNoResults($event)"
            (typeaheadLoading)="isLoading = $event"
            [dropup]="dropup"
            [container]="container"

            (keyup)="onKeyup($event)"
            (blur)="onBlur()"
            [class.ng-invalid]="ngControl.invalid"
            [required]="required"
            [disabled]="disabled"
            [readonly]="readonly"
            autocomplete="off"
            placeholder="Digite para pesquisar...">

        <span *ngIf="isLoading">
            <i class="fas fa-spinner fa-pulse loading-indicator"></i>
        </span>            

        <div class="input-group-append">
            <button type="button" class="btn btn-light" (click)="search()" tabindex="-1" [disabled]="disabled">
                <i class="fas fa-search" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn btn-light" (click)="clear()" tabindex="-1" [disabled]="disabled">
                <i class="fas fa-eraser" aria-hidden="true"></i>
            </button>
        </div>
    </div>
    <p class="form-text text-muted" *ngIf="typeaheadNoResults === true">Nenhum mercado encontrado</p>

<!-- Modal de pesquisa -->
<sgt-mercado-filter-modal
    #filterModal
    idModal="mercadoFilterModal"
    [situacao]="situacao"
    (selectEntity)="onSelectEntityModal($event)">
</sgt-mercado-filter-modal>
